import { useLocation, useNavigate } from 'react-router-dom';

export const useNavigateWithParams = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navigateWithParams = (to: string): void => {
    const searchParams = new URLSearchParams(location.search);

    searchParams.delete('step');

    const queryString = searchParams.toString();

    navigate(queryString ? `${to}?${searchParams.toString()}` : to, { replace: true });
  };

  return navigateWithParams;
};
